
import Home from "./components/Home";
import "./sass/index.scss";
function App() {
  return (
    <div className="app-container" >
      <Home />
    </div>
  );
}

export default App;